import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { Button, Container, Flex, Heading, Icon } from "@huub-web/ui";
import { Illustration, Section } from "@huub-web/shared";

type NotFoundScreenProps = {
  /**
   * Callback fired when the user clicks the "go home" button.
   */
  onGoHome: () => void;
};

/**
 * Full-page 404 screen displayed inside the app layout when the current
 * route does not match any known navigation path. Shows the "notFound"
 * illustration, a translated title/description, and a button to navigate
 * back to the main page.
 */
export const NotFoundScreen: FC<NotFoundScreenProps> = ({ onGoHome }) => {
  const { t } = useTranslation();

  return (
    <Flex
      direction="column"
      justify="center"
      align="center"
      style={{ flex: 1 }}
    >
      <Section>
        <Container size="marketing">
          <Flex direction="column" gap="l" align="center">
            <Illustration
              name="notFound"
              alt="404"
              alignSelf="center"
              size="l"
            />
            <Heading
              variant="secondary"
              title={t("404.title")}
              description={t("404.body")}
            />
            <Button
              variant="secondary"
              trailing={<Icon icon="chevronRight" />}
              onClick={onGoHome}
            >
              {t("404.button")}
            </Button>
          </Flex>
        </Container>
      </Section>
    </Flex>
  );
};
